<template>
  <div>
    <div class="head">
      <SecondaryTitle :align="isMobile ? 'center' : 'left'" v-if="!hideTitle">
        <span v-t="'Sign in'" />
      </SecondaryTitle>
      <!-- <v-btn :to="{ name: 'register' }" class="button-link" text small> -->
      <v-btn v-if="registerLink" :to="registerLink" class="button-link" text small>
        <v-icon class="icon signArrow">mdi-arrow-right</v-icon>
        <span v-t="'Create new account'" />
      </v-btn>
    </div>
    <base-separator v-t="'Login quickly'" class="mt-0" />

    <SocialAuth btn-class="ma-1" rounded dark large @auth="afterAuthenticated" />
    <base-separator v-t="'Or login with email'" />

    <form ref="form" :action="formAction" :method="formMethod">
      <span v-show="false" v-html="csrfTokenInput"></span>
      <v-row class="spacing3">
        <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            v-model="form.email"
            :error-messages="form.error('email')"
            :error="form.state('email')"
            :label="$t('Email')"
            :rules="rules.email"
            name="email"
            required
            v-bind="$pr.textField"
          />
        </v-col>
        <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            v-model="form.password"
            :error-messages="form.error('password')"
            :error="form.state('password')"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :label="$t('Password')"
            :rules="rules.password"
            name="password"
            required
            v-bind="$pr.textField"
          />
        </v-col>
      </v-row>
      <div class="form-helper">
        <div class="form-control-label">
          <v-checkbox
            v-model="form.remember"
            :error-messages="form.error('remember')"
            :error="form.state('remember')"
            :label="$t('Remember me')"
            color="secondary"
            name="remember"
          />
        </div>
        <v-btn small class="button-link" text :to="{ name: 'forgot-password' }">
          <span v-t="'Refresh Password'" />
        </v-btn>
      </div>

      <div class="form-footer">
        <v-alert v-if="errorMessage" type="error">
          <span v-html="errorMessage" />
        </v-alert>
        <div class="btn-area">
          <v-btn
            large
            block
            color="secondary"
            @click.prevent="onSubmit"
            type="submit"
            name="submit"
            :loading="loading"
          >
            <span v-t="'Continue'" />
          </v-btn>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SocialAuthOld from "./SocialAuthOld";
import { csrfTokenInput } from "@/landing/common/meta/csrf-token";
import routerLink from "@/landing/static/text/link";
import SecondaryTitle from "../MainTitle/SecondaryTitle";
import SocialAuth from "@/_shared/components/auth/SocialAuth";
import Form from "@/landing/common/form";
import validationMixin from "@/landing/mixins/validationMixin";

export default {
  mixins: [validationMixin],
  components: {
    SocialAuth,
    SecondaryTitle,
    SocialAuthOld,
  },
  props: {
    formAction: {
      type: String,
      default: null,
    },
    formMethod: {
      type: String,
      default: null,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    registerLink: {
      type: [Object, Boolean],
      default: () => {
        return { name: "register" };
      },
    },
  },
  data() {
    return {
      csrfTokenInput,
      routerLink: routerLink,
      form: new Form({
        email: "",
        password: "",
        remember: false,
      }),
      checkbox: false,
      //   valid: true,
      //   email: "",
      //   password: "",
      loading: false,
      showPassword: false,
      errorMessage: null,
    };
  },
  methods: {
    onSubmit() {
      //   if (this.$refs.form.validate()) {
      //     console.log("data submited");
      //   }
      this.submit();
    },
    afterAuthenticated(response) {
      this.$store.dispatch("fetchAll");
      if (this._.get(response, ["data", "intended"], null)) {
        return window.location.replace(response.data.intended);
      }

      this.$emit("authenticated");
    },
    submit() {
      this.loading = true;
      this.clearMessages();

      /* eslint-disable no-unused-vars */
      //   this.axios.get("/sanctum/csrf-cookie").then(() => {
      this.form
        .post("global/auth/login", "/")
        .then((response) => {
          this.$emit("change");
          this.loading = false;

          this.afterAuthenticated(response);
        })
        .catch((error) => {
          this.errorMessage = this._.get(
            error,
            ["response", "data", "message"],
            this._.get(error, "message", null),
          );
          this.loading = false;
        });
      //   });
    },
    clearMessages() {
      this.errorMessage = null;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;

      //   const smDown = this.$store.state.breakpoints.smDown
      //   return smDown.indexOf(this.$mq) > -1
    },
  },
};
</script>
